import React, {Component} from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import StyleSheet from 'styles/StyleSheet'
import Noise from 'img/noise.png'
import { DealSheetUtils } from 'utils'
import { authorizedLink } from 'utils'
import ButtonBase from '@material-ui/core/ButtonBase'
import { withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'

export class DealSheetCard extends Component{

  static propTypes = {
    showCountdownTimer: PropTypes.bool,
    showProgressBar:    PropTypes.bool,
    showTarget:         PropTypes.bool,
    showRaised:         PropTypes.bool,
    showRoi:            PropTypes.bool,
    showLabels:         PropTypes.bool,
    openLinksInNewTabs: PropTypes.bool,
    dealSheet:          PropTypes.object.isRequired,
    className:          PropTypes.string,
    labelWith:          PropTypes.oneOf(['state', 'eligibility']),
  }

  static defaultProps = {
    showProgressBar: false,
    openLinksInNewTabs: false,
    className: '',
    labelWith: 'state'
  }
  /**
   * Start our periodic refresh of the timer component
   */
  componentDidMount = () => {
    this.refreshInterval = global.setInterval(() => {
      this.forceUpdate()
    }, 1000)
  }

  /**
   * End our periodic refresh of the timer component
   */
  componentWillUnmount = () => {
    global.clearInterval(this.refreshInterval)
  }


  get attributes(){
    return this.props.dealSheet
  }

  /**
   * Calculate the values and labels for the countdown-timer
   */
  get countdownStatus(){
    return DealSheetUtils.countdownStatus(this.props.dealSheet)
  }

  /**
   * #TODO
   * Calculate the ROI between the public sale rate and the current market/exchange spot-rate
   */
  get roiStatus(){
    return {
      increase: this.attributes.roi > 0,
      value: `${this.attributes.currentPriceFormatted}${this.currencyCode}`,
      change: `${Math.abs(this.attributes.roi)}`
    }
  }

  get currencyCode(){
    return this.attributes.currency && this.attributes.currency.code
  }

  get labelButtonText(){
    const { status, eligible } = this.props.dealSheet
    if(this.props.labelWith === 'state') {
      return <FormattedMessage id={`deal.status.${status}`} />
    } else {
      return <FormattedMessage id={`deal.investor_status.${eligible ? 'eligible' : 'ineligible'}`} />
    }
  }

  get labelButtonColor(){
    const ineligibleColor = '#6AAEAA'
    const eligibleColor   = '#586c7b'
    const activeColor     = '#90c814'

    const { eligible } = this.props.dealSheet

    if(this.props.labelWith === 'state') {
      return activeColor
    } else {
      return eligible ? eligibleColor : ineligibleColor
    }
  }

  get showCountdownTimer() {
    if (this.props.showCountdownTimer === undefined) {
      return this.props.dealSheet.typeOfIssuance !== 'product'
    }
    return this.props.showCountdownTimer
  }

  handleShow = () => {
    setTimeout(() => {
      if (this.props.openLinksInNewTabs)
        window.location.href = `/deal_sheets/${this.props.dealSheet.id}/view`
      else
        this.props.history.push(`/deal_sheets/${this.props.dealSheet.id}/view`)
    }, 200)
  }

  renderLabelButton(){
    return (
      <button style={{backgroundColor: this.labelButtonColor}}>{this.labelButtonText}</button>
    )
  }

  renderProgressBar = () =>
    [
      <div key='progress' className={styles.progressBarWrapper}>
        <div className={styles.progressBarText}>
          <div className={styles.progressBarRaised}>
            <p className={styles.progressBarlabel}>Raised</p>
            <p className={styles.progressBarAmount}>
              {(parseFloat(this.attributes.amountRaised) || 0).toLocaleString()} {this.currencyCode}
            </p>
          </div>
          <div className={styles.progressBarTarget}>
            <p className={styles.progressBarlabel}>Target</p>
            <p className={styles.progressBarAmount}>
              {(parseFloat(this.attributes.saleCap) || 0).toLocaleString()} {this.currencyCode}
            </p>
          </div>
        </div>
        <div className={styles.progressBar}>
          <div style={{width: `${Math.max(0, Math.min(1, this.attributes.amountRaised / this.attributes.saleCap)) * 100.0}%`}} className={styles.progressBarInner}>
          </div>
        </div>
      </div>,
      this.props.showLabels &&
        <div key='labels' className={styles.labelsContainer}>
          <div className={styles.taxonomy}/> { /* placeholder for taxonomies */ }
          <div key='buttons' className={styles.cardActionButtons}>
            { this.renderLabelButton() }
          </div>
        </div>
    ]

  renderTarget = () =>
    <div className={styles.targetSection}>
      <div className={styles.target}>
        {this.props.showTarget &&
          <div className={styles.progressLabel}>
            <p className={styles.targetlabel}>Target</p>
            <p className={styles.targetAmount}>
              {(parseFloat(this.attributes.saleCap) || 0).toLocaleString()} {this.currencyCode}
            </p>
          </div>
        }
        {this.props.showRaised &&
          <div className={styles.progressLabel}>
            <p className={styles.targetlabel}>Raised</p>
            <p style={{color: this.attributes.paymentReceived > this.attributes.saleCap ? '#f72d1c' : ''}}className={styles.targetAmount}>
              {(parseFloat(this.attributes.paymentReceived) || 0).toLocaleString()} {this.currencyCode}
            </p>
          </div>
        }
      </div>
      {this.props.showLabels &&
        <div className={styles.targetButtons}>
          { this.renderLabelButton() }
        </div>
      }
    </div>


  renderCountdownTimer = () => {
    const status = this.countdownStatus
    return (
      <div className={styles.countdownTimer}>
        <p className={styles.countdownMain}>
          <span className={styles.countdownLive}>
            <small>{status.prefix}</small>
            {status.timeRemaining}
          </span>
        </p>
        <small className={styles.countdownSmall}>
          {status.info}
        </small>
      </div>
    )
  }

  renderRoi = () =>  {
    const status = this.roiStatus
    return (
      <div className={styles.roi}>
        <span className={styles.roiValue}>
          {status.value}
        </span>
        <span  className={styles('roiPercentageChange', {roiUpwards: status.increase, roiDownwards: !status.increase})}>
          {status.change}%{status.increase ? '▲' : '▼'}
        </span>
      </div>
    )
  }

  render = () => {
    const classes = classnames(
        styles.cardContainer,
        this.props.className
      )
    return (
      <ButtonBase component='div' className={classes} onClick={this.handleShow}>
        <div className={styles.cardBody} style={{backgroundImage: (this.props.dealSheet.theme && this.props.dealSheet.theme.backgroundImage)}}>
          <div className={styles.noiseContainer}>
            <div style={{backgroundImage: `url(${Noise})`}} className={styles.noise}></div>
          </div>
          <div className={styles.logo}>
            {
              this.props.dealSheet.emblemUrls.avatar &&
              <img alt='' className={styles.emblem} src={authorizedLink(this.props.dealSheet.emblemUrls.avatar)}/>
            }
            {this.attributes.name} {this.attributes.ticker && `(${this.attributes.ticker})`}
          </div>
          <div className={styles.byline}>
            {this.attributes.tagLine}
          </div>
          {this.showCountdownTimer && this.renderCountdownTimer()}
          {this.attributes.roi && this.props.showRoi && this.renderRoi()}
        </div>
        <div className={styles.cardActions}>
          {
            this.props.showProgressBar ?
              this.renderProgressBar() :
              this.renderTarget()
          }
        </div>
      </ButtonBase>
    )
  }
}

export default withRouter(DealSheetCard)

const styles = StyleSheet({
  noiseContainer: {
    width: 0,
    height: 0,
    padding: 1,
    overflow: 'visible'
  },
  noise: {
    marginTop: -20,
    marginLeft: -40,
    width: 10000,
    height: 10000,
    backgroundRepeat: 'repeat'
  },
  cardContainer: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'stretch',
    flex: '1 0 auto',
    minWidth: 330,
    minHeight: 220,
    margin: '0 10px',
    flexDirection: 'column',
    transition: 'filter 350ms',
    fontFamily: 'Montserrat,sans-serif',
    '*': {
      fontFamily: 'Montserrat,sans-serif'
    },
    '&:hover': {
      filter: 'brightness(104%) saturate(120%)',
      cursor: 'pointer'
    },
  },
  cardContainerWithTimer: {
  },
  cardBody: {
    flex: 1,
    padding: 20,
    color: '#fff',
    backgroundImage: 'linear-gradient(109deg, #473b7b, #3584a7 51%, #30d2be)'
  },
  emblem: {
    maxWidth: 100,
    maxHeight: 42,
    marginRight: 6,
    verticalAlign: 'middle'
  },
  logo: {
    fontWeight: 'bold',
    fontSize: 32,
    '& a' : {
      width: '100%',
      display: "inline-block",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: 'inherit !important',
      textDecoration: 'none !important',
      alignItems: 'center',
      '&:hover': {
        textDecoration: 'none !important',
        opacity: '1 !important'
      }
    },
    '@media(max-width: 600px)': {
      whiteSpace: 'unset'
    }
  },
  byline: {
    fontSize: 12,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    marginTop: 5,
    marginBottom: 35
  },
  countdownMain: {
    '& small': {
      'fontSize': 12,
      fontWeight: 'bold',
      marginRight: 10
    },
    margin: '0 0 10px 0'
  },
  roi: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  roiValue: {
    flex: 0,
    marginRight: 10,
    fontSize: 24,
    fontWeight: 700
  },
  roiPercentageChange: {
    flex: 0,
    fontSize: 16,
    fontWeight: 700
  },
  roiUpwards: {
    color: '#90c814'
  },
  roiDownwards: {
    color: '#f72d1c'
  },
  countdownLive: {
    fontSize: 26,
    fontWeight: 'bold'
  },
  countdownSmall: {
    fontSize: 11
  },
  target: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    // width: '100%'
  },
  progressLabel: {
    flex: 1,
    '&:first_child': {
      marginRight: '10%'
    }
  },
  targetlabel: {
    color: '#a4a4a4',
    fontSize: 12,
    fontWeight: '500',
    marginBottom: 5
  },
  targetAmount: {
    color: '#464646',
    fontSize: 18,
    fontWeight: '500',
    marginTop: 0,
    marginBottom: 10
  },
  progressBarlabel: {
    color: '#a4a4a4',
    fontSize: 12,
    fontWeight: '500',
    marginBottom: 5
  },
  progressBarAmount: {
    color: '#464646',
    fontSize: 18,
    fontWeight: '500',
    marginTop: 0,
    marginBottom: 10
  },
  progressBarText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  progressBar: {
    width: '100%',
    height: 15,
    borderRadius: 6,
    overflow: 'hidden',
    background: '#cacaca'
  },
  progressBarInner: {
    height: '100%',
    background: '#464646'
  },
  cardActions: {
    backgroundColor: '#e8e8e8',
    padding: '10px 20px',
    flex: 0,
    color: "#464646"
  },
  cardActionButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    padding: '10px 0',
    '& button': {
      padding: '10px 30px',
      minWidth: 130,
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center',
      color: 'white',
      backgroundColor: '#90c814',
      textTransform: 'uppercase',
      border: 'none',
      borderRadius: 3,
    }
  },
  labelsContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  taxonomy: {

  },
  targetSection: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  targetButtons: {
    display: 'flex',
    flex: 1,
    flexGrow: 1,
    justifySelf: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '10px 0',
    '& button': {
      padding: '10px 30px',
      minWidth: 130,
      fontSize: 14,
      fontWeight: 'bold',
      textAlign: 'center',
      color: 'white',
      backgroundColor: '#90c814',
      textTransform: 'uppercase',
      border: 'none',
      borderRadius: 3,
    }
  }
})